// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/activity.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from message omnios.v1.ActivityEntry
 */
export const ActivityEntry = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ActivityEntry",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "actor_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "actor_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "payload", kind: "message", T: Struct },
    { no: 8, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ListActivityRequest
 */
export const ListActivityRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListActivityRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListActivityResponse
 */
export const ListActivityResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListActivityResponse",
  () => [
    { no: 1, name: "entries", kind: "message", T: ActivityEntry, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.ListEntityActivityRequest
 */
export const ListEntityActivityRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEntityActivityRequest",
  () => [
    { no: 1, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListEntityActivityResponse
 */
export const ListEntityActivityResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEntityActivityResponse",
  () => [
    { no: 1, name: "entries", kind: "message", T: ActivityEntry, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

